import clsx from 'clsx'
import {useEffect} from 'react'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {appUrl} from '../../../AppUrl'
import {trans} from '../../../helpers'
import {useAuthStore} from '../../../stores'

interface TopNavigationCreateAdButtonProps {
    forMobile: boolean
    wrappedInCard?: boolean
}

export function TopNavigationCreateAdButton(props: TopNavigationCreateAdButtonProps) {
    const {
        wrappedInCard = false,
        forMobile = false,
    } = props

    const setOnRegistrationSuccess = useAuthStore(
        state => state.setOnRegistrationSuccess
    )
    const setOnLoginSuccess = useAuthStore(
        state => state.setOnLoginSuccess
    )

    const url = appUrl().cabinet.ads.create
    const label = trans().common.top_navigation.add_advertisement

    // Настраиваем поведение после логина и регистрации.
    useEffect(() => {
        setOnRegistrationSuccess(() => {
            NavigationService.navigate(appUrl().cabinet.ads.create)
            return 'stop'
        })
        setOnLoginSuccess(() => {
            NavigationService.navigate(appUrl().cabinet.ads.create)
        })
    }, [])

    if (forMobile) {
        return (
            <Button
                color="gray"
                outline
                className={clsx(
                    'text-nowrap full-width mt-2',
                    'btn-hover-theme'
                )}
                href={url}
            >
                {label}
            </Button>
        )
    } else {
        return (
            <Button
                color={wrappedInCard ? 'blue' : 'gray'}
                outline={!wrappedInCard}
                className={clsx(
                    'text-nowrap top-nav-add-offer',
                    wrappedInCard ? null : 'btn-hover-theme'
                )}
                href={url}
            >
                <span>{label}</span>
            </Button>
        )
    }
}
